import { CardContent, Typography, Button, Card as MuiCard, IconButton, Box } from "@material-ui/core";
import useStyles from "../../../assets/styles/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import RoomIcon from "@material-ui/icons/Room";
import ContactPageIcon from '@mui/icons-material/ContactPage';
import LocationCityIcon from "@material-ui/icons/LocationCity";
import AddIcon from "@material-ui/icons/Add";
import { formatRawPhoneNumber, getPrestadorLocationLines } from "../../../utils/utilsFunctions";
import CustomButton from "../../../controls/Button/CustomButton";

const MedicalCard = ({ item, i, handleClick, showMaps, mapContainer, currentPosition }) => {
    const classes = useStyles();

    return (
        <>
            <MuiCard key={i} className={`${classes.cardMedicalData} ${classes.newStyleTopBorderCardCard} ${classes.muiCardStylesCard}`}>
                <Box className={classes.headerStripeCard} />
                <CardContent className={classes.contentsCardMuiCard}>
                    <Box className={classes.divCardContentMedicalCard}>
                        <Box className={classes.cardMedicalCenterSection}>
                            <Box className={classes.cartillaClasificacionPrestadorStyles}>
                                {
                                    item?.clasificacionPrestador === "CENTRO MEDICO" ? (
                                        <LocationCityIcon className={classes.LocationCityIcon} />
                                    ) : (
                                        <ContactPageIcon className={classes.contactPageIcon} />
                                    )
                                }
                            </Box>
                            <Box className={`${classes.divTitleCardCartilla} ${classes.addressBlock} ${classes.cardProviderCompanyNameStyles}`}>
                                <Typography className={classes.styleCompanyName} >{item?.prestadorRazonSocial}</Typography>
                            </Box>
                            <Box className={classes.cartillaButtonContainerStyles}>
                                <Typography className={classes.styleShowMoreArrowIconCard} component={Button} onClick={handleClick(item, i)}>
                                    <ChevronRightIcon className={classes.showMoreArrowIconCard} />
                                </Typography>
                            </Box>
                            <Box className={classes.cartillaButtonMapsStyles}>
                                {mapContainer ?
                                    <a
                                        target="_blank"
                                        style={{ textDecoration: "none" }}
                                        href={
                                            "https://www.google.com/maps/dir/?api=1&origin=" +
                                            currentPosition?.lat +
                                            "%2C" +
                                            currentPosition?.lng +
                                            "&destination=" +
                                            item?.prestadorLatitud +
                                            "%2C" +
                                            item?.prestadorLongitud +
                                            "&travelmode=driving"
                                        }
                                    >
                                        <CustomButton
                                            title={"como llegar"}
                                            customClass={`${classes.customBtnMapsMedicalCard} ${classes.darkLinearGradient}`}
                                        />
                                    </a>
                                    :
                                    <IconButton className={classes.roomIconStylesCard} onClick={showMaps(item, i)}>
                                        <RoomIcon />
                                    </IconButton>
                                }
                            </Box>
                        </Box>
                        <Box className={`${classes.telephoneSectionCard} ${classes.addressBlock}`}>
                            <Box className={classes.styleTelephoneSectionCard}>
                                <a href={`tel:${item?.telefono[0]?.telefonoNumero}`} className={`${classes.txtLinksOnCard} ${classes.txtDescription} ${classes.txtEllipsis}`}>
                                    {formatRawPhoneNumber(item?.telefono[0]?.telefonoNumero?.trim())}

                                </a>
                                {
                                    item?.telefono?.length > 1 &&
                                    (
                                        <AddIcon className={`${classes.txtLinksOnCard} ${classes.cartillaAddIconStyles}`} onClick={handleClick(item, i)}></AddIcon>
                                    )
                                }
                            </Box>
                            <Box className={classes.cardProviderAddressContainer} style={{ alignItems: 'center' }}>
                                <Box>
                                    <Box >
                                        <Typography  className={`${classes.addressStyleCard} ${classes.addressBlock}`}>
                                            {item?.prestadorDomicilio}
                                        </Typography>
                                    </Box>
                                    {getPrestadorLocationLines(item).map((line, index) => (
                                        <Typography
                                            key={index}
                                            className={`${classes.addressStyleCard}`}
                                        >
                                            {line}
                                        </Typography>
                                    ))}

                                    <Box className={classes.cartillaLineFixedHeight}>

                                        {item?.mail[0]?.mailDireccion?.trimEnd() !== '' &&
                                            <Box className={classes.boxTxtMailOnCard}>
                                                <a href={`mailto:${item?.mail[0]?.mailDireccion}`} className={`${classes.txtLinksOnCard} ${classes.txtDescription} ${classes.txtEllipsis}`}>
                                                    {item?.mail[0]?.mailDireccion?.trimEnd()}
                                                </a>
                                                <AddIcon className={`${classes.txtMailOnCard}`} onClick={handleClick(item, i)}></AddIcon>
                                            </Box>
                                        }
                                    </Box>
                                </Box>
                            </Box>
                            <Box className={classes.cartillaObservacionStyles}>
                                <Typography className={`${classes.txtDescriptionMedicalCard}`}>
                                    {item?.observacion}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </CardContent>
            </MuiCard >
        </>
    );
};

export default MedicalCard;